// generate ISO690 standard citation format: https://uc3m.libguides.com/guias_tematicas/citas_bibliograficas/une-iso-690#ebook

function getIso690Edition(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'edition') ? `(${tags.edition.join(', ')})` : '';
}
function getIso690Country(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'country') ? `${tags.country.join(', ')}: ` : '';
}
function getIso690Authors(tags, localizations) {
    if (!Object.prototype.hasOwnProperty.call(tags, 'author') || tags.author[0] === undefined) {
        return '';
    }

    switch (tags.author.length) {
        case 1:
            return capitalizeLastName(tags.author[0]);
        case 2:
            return `${capitalizeLastName(tags.author[0])} ${localizations.citation.messages.and} ${capitalizeLastName(
                tags.author[1]
            )}`;
        default:
            return `${capitalizeLastName(tags.author[0])}, et al.`;
    }
}

function capitalizeLastName(author) {
    author = author.split(' ');
    const lastName = author.pop();
    author.unshift(`${lastName.toUpperCase()},`);
    return author.join(' ');
}

function getIso690Publisher(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'publisher') ? tags.publisher.join(', ') : '';
}
function getIso690PublicationDate(issue) {
    return Object.prototype.hasOwnProperty.call(issue, 'publication_date') ? `${issue.publication_date}` : '';
}
function getIso690Title(issue, title, localizations) {
    return Object.prototype.hasOwnProperty.call(issue, 'title') && issue.title.length
        ? `${issue.title} [${localizations.citation.messages.online}]`
        : `${title} [${localizations.citation.messages.online}]`;
}
function getIso690IssueUrl(issue, currentLocation, isEpub = false, localizations) {
    const location = isEpub ? btoa(JSON.stringify(currentLocation)) : currentLocation;
    return Object.prototype.hasOwnProperty.call(issue, 'issue_url') > 0
        ? `${localizations.citation.messages.availableIn}: ${issue.issue_url}?location=${location}`
        : '';
}

function getDateNow(localizations) {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1;
    const day = now.getDate() < 10 ? `0${now.getDate()}` : now.getDate();
    return `[${localizations.citation.messages.generated}: ${year}-${month}-${day}]`;
}
function getIso690ISBN(issue) {
    return issue.externalId !== '' ? `ISBN: ${issue.externalId}` : '';
}

function formatValue(string) {
    const trimmedString = string.trim();
    if (!trimmedString) {
        return '';
    }
    return trimmedString.endsWith('.') ? `${trimmedString} ` : `${trimmedString}. `;
}

const Iso690 = (text, issue, currentLocation, issueTitle, isEpub, localizations) => {
    const author = getIso690Authors(issue.tags, localizations);
    const date = getIso690PublicationDate(issue);
    const title = getIso690Title(issue, issueTitle, localizations);
    const edition = getIso690Edition(issue.tags);
    const country = getIso690Country(issue.tags);
    const publisher = getIso690Publisher(issue.tags);
    const url = getIso690IssueUrl(issue, currentLocation, isEpub, localizations);
    const dateNow = getDateNow(localizations);
    const isbn = getIso690ISBN(issue);

    const citation = `${formatValue(author)}${formatValue(date)}${formatValue(title)}${formatValue(edition)}${formatValue(country, ':')}${formatValue(publisher)}${formatValue(isbn)}${formatValue(dateNow)}${url}`;

    if (text && text.trim()) {
        return `"${text}"

${citation}`;
    }

    return citation;
};

export default Iso690;
